import React, { useRef, Fragment } from 'react';
import { observer } from 'mobx-react';
import { mdiCogs } from '@mdi/js';
import { CustomInput } from 'reactstrap';
import stores from 'cd-eft/models/Stores';
import { Popup } from 'cd-eft/components/common/Popup';
import { DesignSettingsVM } from './DesignSettingsVM';

import './DesignSettings.scss';
import { SelectOption } from 'cd-eft/components/common/SelectOption';

const designStore = stores.AppStore?.designStore;

const DesignSettingsComponent = () => {
  const vmRef = useRef<DesignSettingsVM>();
  if (vmRef.current === undefined) {
    vmRef.current = new DesignSettingsVM();
  }
  const vm = vmRef.current;

  return (
    <>
      {designStore.showSettingsPopup && (
        <Popup
          icon={mdiCogs}
          trigger={designStore.showSettingsPopup}
          setTrigger={vm.togglePopupHandler}
          title="Settings"
          handleCancel={vm.togglePopupHandler}
          cancelText="Close"
          handleOK={vm.saveSettingsHandler}
          okText="Ok"
        >
          <div className="tab-design-list-container bg-white">
            <div className="rcn-top-nav design-settings-list-tabs">
              <ul>
                <li className="table-name">
                  <button
                    data-testid="designsummarytab"
                    className={
                      designStore.currentDesignSettingsTab === designStore.designSettingsTabs[0] ? 'active' : ''
                    }
                    onClick={() => {
                      designStore.currentDesignSettingsTab = designStore.designSettingsTabs[0];
                    }}
                  >
                    <strong>General</strong>
                  </button>
                </li>

                <li className="table-name">
                  <button
                    data-testid="newdesigntab"
                    className={
                      designStore.currentDesignSettingsTab === designStore.designSettingsTabs[1] ? 'active' : ''
                    }
                    onClick={() => {
                      designStore.currentDesignSettingsTab = designStore.designSettingsTabs[1];
                    }}
                  >
                    <strong>Land Leveling</strong>
                  </button>
                </li>

                <li className="table-name">
                  <button
                    data-testid="bordereditingtab"
                    className={
                      designStore.currentDesignSettingsTab === designStore.designSettingsTabs[2] ? 'active' : ''
                    }
                    onClick={() => {
                      designStore.currentDesignSettingsTab = designStore.designSettingsTabs[2];
                    }}
                  >
                    <strong>Border Editing</strong>
                  </button>
                </li>

                <li className="table-name">
                  <button
                    data-testid="aidesigntab"
                    className={
                      designStore.currentDesignSettingsTab === designStore.designSettingsTabs[3] ? 'active' : ''
                    }
                    onClick={() => {
                      designStore.currentDesignSettingsTab = designStore.designSettingsTabs[3];
                    }}
                  >
                    <strong>AI Design</strong>
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {designStore.currentDesignSettingsTab === 'General' ? (
            <CustomInput
              type="switch"
              id="expressModeSwitch"
              data-testid="expressModeSwitch"
              name="expressModeSwitch"
              label="Load surface in express mode - only TIN layer"
              checked={vm.surfaceExpressMode}
              onChange={vm.expressModeSwitchHandler}
            />
          ) : null}

          {designStore.currentDesignSettingsTab === 'Land Leveling' ? (
            <Fragment>
              <div className="stake-out-settings">
                <div className="select-dropdown">
                  <SelectOption
                    label="Default numeric input for stakeout grid"
                    idAndName="stakeout-grid-numeric-input"
                    options={[
                      {
                        value: 100,
                        name: '100',
                        label: '100 ft',
                      },
                      {
                        value: 200,
                        name: '200',
                        label: '200 ft',
                      },
                      {
                        value: 300,
                        name: '300',
                        label: '300 ft',
                      },
                      {
                        value: 400,
                        name: '400',
                        label: '400 ft',
                      },
                      {
                        value: 500,
                        name: '500',
                        label: '500 ft',
                      },
                    ]}
                    value={vm.cellSize}
                    onChange={(e) => {
                      vm.handleGridChange(e);
                    }}
                    className="usa-select margin-top-0 display: inline-flex"
                  />

                  {/* <select
                    className="usa-select margin-top-0 display: inline-flex"
                    name="stakeout-grid-input-type"
                    id="stakeout-grid-input-type"
                    data-testid="stakeout-grid-input-type"
                  >
                    <option value="feet" label="feet">
                      feet
                    </option>
                    <option value="centimeters" label="centimeters">
                      centimeters
                    </option>
                    <option value="meters" label="meters">
                      meters
                    </option>
                    <option value="inches" label="inches">
                      inches
                    </option>
                  </select> */}
                </div>
              </div>
            </Fragment>
          ) : null}

          {designStore.currentDesignSettingsTab === 'Border' ? (
            <Fragment>
              <div className='m-2 d-flex'>
                <label htmlFor="add-distance">Maximum Distance When Adding Border Point</label>
                <input id='add-distance' value={vm.distanceAdd}
                  onChange={(e) => {
                    vm.distanceAdd = Number(e.target.value);
                  }} />
                <label className='ms-3 align-self-center'>ft.</label>
              </div>

              <div className='m-2 d-flex'>
                <label htmlFor="delete-distance">Maximum Distance When Deleting Border Point</label>
                <input id='delete-distance' value={vm.distanceDelete}
                  onChange={(e) => {
                    vm.distanceDelete = Number(e.target.value);
                  }} />
                <label className='ms-3 align-self-center'>ft.</label>
              </div>
            </Fragment>
          ) : null}

          {designStore.currentDesignSettingsTab === 'AI' ? (
            <Fragment>

              <label htmlFor="ai-keycode" className='m-2'>Human Feedback Code</label>
              <input id='ai-keycode' type='password' maxLength={7}
                onChange={(e) => {
                  (e.target.value === "54321") ? vm.activateAiMode() : vm.deactivateAiMode();
                }} />
              <CustomInput
                type="switch"
                id="AiZoomToActionSwitch"
                data-testid="AiZoomToActionSwitch"
                name="AiZoomToActionSwitch"
                label="Toggle Zoom To AI Action"
                checked={vm.switchAiZoomToAction}
                onChange={vm.toggleAiZoomToAction}
              />
            </Fragment>
          ) : null}
        </Popup>
      )}
    </>
  );
};

export const DesignSettings = observer(DesignSettingsComponent);
